import { combineReducers } from "redux";
import tabsReducer from "./tabs.reducers";
import mattersReducer from "./matters.reducer";
import nominalReducer from "./nominal.reducer";
import usersListReducer from "./users.reducer";
import currentuserReducer from "./currentuser.reducer";
import CurrencyReducer from "./currency.reducer";
import PostingsDetails from "./postings.reducer";
import TransactionPeriodReducer from "./transactionperiod.reducer";
import OpenProfileReducer from "./profileopener.reducer";
import AutoLoginReducer from "./autologin.reducer";
import TransactionReducer from "./postingDetails.reducer";
import FilesDownload from "./filesDownlaod.reducer";
import contactsReducer from "./contacts.reducer";
import timeReducer from "./time.reducer";
import billReducer from "./bill.reducer";
import HeaderName from "./header.reducer";
import ChitRequestReducer from "./chitRequest.reducer";
import ledgerLinks from "./ledgerlinks.reducer";
import chitPostingReducer from "./chitPosting.reducer";
import ProfitCostTemplate from "./fixedFeeHeader.reducer";
import ApplicationReducer from "./applications.reducer";
import CommonReducer from "./common.reducer";
import clientsReducer from "./clients.reducer";
import ReferrerReducer from "./referrer.reducer";
import SourcesReducer from "./sources.reducer";
import CaseFilesReducer from "./casefiles.reducer";
import DocTypeReducer from "./doctype.reducer";
import TimeTypeReducer from "./timeType.reducer";
import BillingRequestsReducer from "./billingRequests.reducer";
import ctoSweepReducer from "./ctosweep.reducer";
import { branchReducer } from "services/branchService";
import { vatReducer } from "services/vatService";
import { currentUserReducer } from "services/currentUserService";
import { currentUserSettingsReducer } from "services/userSettingsService";
import { usersReducer } from "services/userService";
import { departmentReducer } from "services/departmentService";
import { workTypeReducer } from "services/workTypeService";
import { supplierReducer } from "services/supplierService";
import { companyReducer as CompanyServiceReducer } from "services/companyService";
import { activityTypeReducer } from "services/activityTypeService";
import { dashboardReducer } from "services/dashboardService";
import { applicationSettingsReducer } from "services/applicationSettingsService";
import dialogReducer from "reducers/errorDialogSlice";

const rootReducer = combineReducers({
  tabsData: tabsReducer,
  mattersList: mattersReducer,
  contactsList: contactsReducer,
  nominalList: nominalReducer,
  suppliers: supplierReducer,
  usersList: usersListReducer,
  currentuser: currentuserReducer,
  currentUser: currentUserReducer,
  currentUserSettings: currentUserSettingsReducer,
  users: usersReducer,
  company: CompanyServiceReducer,
  time: timeReducer,
  branches: branchReducer,
  vats: vatReducer,
  currency: CurrencyReducer,
  postingsdocs: PostingsDetails,
  transactionperiods: TransactionPeriodReducer,
  openProfile: OpenProfileReducer,
  loginOn: AutoLoginReducer,
  transaction: TransactionReducer,
  filesDownload: FilesDownload,
  billsMatterData: billReducer,
  headerName: HeaderName,
  chitRequest: ChitRequestReducer,
  ledgerLinks: ledgerLinks,
  chitPosting: chitPostingReducer,
  profitCostTemplate: ProfitCostTemplate,
  applications: ApplicationReducer,
  common: CommonReducer,
  clients: clientsReducer,
  workTypes: workTypeReducer,
  departments: departmentReducer,
  timeTypes: TimeTypeReducer,
  dashboard: dashboardReducer,
  referrers: ReferrerReducer,
  sources: SourcesReducer,
  caseFiles: CaseFilesReducer,
  docTypes: DocTypeReducer,
  billingRequests: BillingRequestsReducer,
  ctoSweep: ctoSweepReducer,
  activityTypes: activityTypeReducer,
  applicationSettings: applicationSettingsReducer,
  errorDialog: dialogReducer,
});

export default rootReducer;
